import React from "react";
import { Form } from "react-bootstrap";
import { Link } from "react-router-dom";

// The SMS opt-in checkbox and its wording: the proof of consent for the
// toll-free SMS registration (Brevo, "Web Form"). Shown on the Profile page and
// on the 2FA setup screen. One component, so the wording carriers were shown
// is exactly the wording clients see in both places. Never ticked by default.
const SmsConsentCheck = ({ id = "smsConsent", checked, onChange, disabled }) => (
  <Form.Group controlId={id} className="sms-consent text-start">
    <Form.Check
      type="checkbox"
      checked={!!checked}
      disabled={disabled}
      onChange={(e) => onChange(e.target.checked)}
      label={
        <>
          I agree to receive text messages from ADM CPA P.C. at the number
          above, including login codes, security alerts, account notifications
          and support replies, sent using an automated system. Consent is not a
          condition of purchase. Message frequency varies. Message and data rates
          may apply. Reply STOP to any text from us to opt out, or HELP for help.
          Your mobile information will not be sold or shared with third parties.
          See our <Link to="/terms" target="_blank">Terms</Link> and{" "}
          <Link to="/privacy-policy" target="_blank">Privacy Policy</Link>.
        </>
      }
    />
  </Form.Group>
);

export default SmsConsentCheck;
